// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"bd3f3ba0","139":"2e83d54e","194":"c8c0862a","197":"04c036f6","436":"6f976629","496":"825c8ed0","587":"e2e318ce","619":"f28b50e4","671":"1e1da1d1","787":"6f5d094e","872":"40279b06","894":"ec7ec9f6","942":"9464e348","984":"bea92ad8"}[chunkId] + ".chunk.js";
};